import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemButton, ListItemText, Typography, Divider } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { PostStatuses } from '../../../../../Utils/Types';
import Dialog from '../../../../DesignSystem/Dialog';
import StatusBadge from '../../../../DesignSystem/StatusBadge';

interface PostStatusHelpDialogProps {
  currentStatus: string;
  statuses: any[];
  open: boolean;
  onClose: () => void;
}

function PostStatusHelpDialog({
  currentStatus,
  statuses,
  open,
  onClose,
}: PostStatusHelpDialogProps) {
  return (
    <Dialog
      id="post-status-help-dialog-title"
      open={open}
      label="post-status-help-dialog-title"
      onClose={onClose}
      title={<FormattedMessage id="POSTS.STATUS.MODAL.TITLE" />}
      disableGutters
    >
      <List>
        {statuses
          .map((status: any) => (
            <ListItem key={status.keyword} disablePadding>
              <ListItemButton
                title={status.keyword}
                selected={status.keyword === currentStatus.keyword}
                disableRipple
              >
                <ListItemText
                  primary={<StatusBadge status={status} />}
                  secondary={
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ mt: 1 }}
                      dangerouslySetInnerHTML={{ __html: status.content }}
                    />
                  }
                />
              </ListItemButton>
            </ListItem>
          ))
          .reduce((prev: any, curr: any) => [
            prev,
            <Divider key={`${prev.keyword}-${curr.keyword}`} />,
            curr,
          ])}
      </List>
    </Dialog>
  );
}

PostStatusHelpDialog.propTypes = {
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      keyword: PropTypes.oneOf(Object.values(PostStatuses)).isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PostStatusHelpDialog;
